/**
 * Central date/time formatting — ALL dates in DD/MM/YYYY, ALL times in IST
 */

const IST_TZ = 'Asia/Kolkata';

/**
 * Format date as DD/MM/YYYY
 */
export function formatDate(dateStr) {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr.includes('T') ? dateStr : dateStr + 'T00:00:00');
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch {
    return dateStr;
  }
}

/**
 * Format date as DD/MM (compact)
 */
export function formatDateShort(dateStr) {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr.includes('T') ? dateStr : dateStr + 'T00:00:00');
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}`;
  } catch {
    return dateStr;
  }
}

/**
 * Normalize time string - ensure space before AM/PM and IST
 */
function normalizeTime(timeStr) {
  return timeStr
    .replace(/\u202f/g, ' ')  // narrow no-break space → regular space
    .replace(/\u00a0/g, ' ')  // non-breaking space → regular space
    .replace(/([ap]m)/i, (m) => m.toUpperCase());
}

/**
 * Format timestamp to time string in IST with "IST" label
 * e.g., "09:15 AM IST"
 */
export function formatTime(ts) {
  if (!ts) return '-';
  try {
    const d = new Date(ts);
    const raw = d.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: IST_TZ,
    });
    return normalizeTime(raw) + ' IST';
  } catch {
    return ts;
  }
}

/**
 * Format timestamp to time with seconds in IST
 * e.g., "09:15:42 AM IST"
 */
export function formatTimeFull(ts) {
  if (!ts) return '-';
  try {
    const d = new Date(ts);
    const raw = d.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZone: IST_TZ,
    });
    return normalizeTime(raw) + ' IST';
  } catch {
    return ts;
  }
}

/**
 * Format full datetime: DD/MM/YYYY, hh:mm AM IST
 */
export function formatDateTime(ts) {
  if (!ts) return '-';
  try {
    const d = new Date(ts);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const raw = d.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: IST_TZ,
    });
    return `${dd}/${mm}/${yyyy}, ${normalizeTime(raw)} IST`;
  } catch {
    return ts;
  }
}

/**
 * Format date as "Mon, 11 Apr 2026"
 */
export function formatDateLong(dateStr) {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr.includes('T') ? dateStr : dateStr + 'T00:00:00');
    return d.toLocaleDateString('en-IN', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
}

/**
 * Get device timestamp in ISO format for audit purposes
 */
export function getDeviceTimestamp() {
  return new Date().toISOString();
}
